
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS ,
    ArcElement,Tooltip,Legend,defaults
 } from 'chart.js';

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend
)

   

export default class DOUGHNUT extends React.Component {

  render() {
    const { graphData, textColor, reportCTA,numberConfig,beforeIcon,reportNameFinal,reportPrimaryColor } = this.props;
    const labels = this.props.rawData && this.props.rawData.columns
    const tableData = this.props.rawData && this.props.rawData.graphData && this.props.rawData.graphData[0] && this.props.rawData.graphData[0].tableData
      let dataSet = []; 
    
    for (let k in tableData) { 
        dataSet.push(tableData[k]);
    }
    const data = {
        labels:labels,
        datasets:[
            {
                label:{reportNameFinal},
                data:dataSet,
                backgroundColor:[reportPrimaryColor,'#d3d3d3'],
                borderColor:[reportPrimaryColor,'#d3d3d3'],
                circumference:180,
                rotation:270,
                weight:0.5

            }
        ]
    }


const options ={
     aspectRatio:2,
     cutout: 40,
     plugins:{
        tooltip:{
            enabled:true
        },
        legend:{
            display:false
        }
     }
}
    return (
       <div>
        <Doughnut
        data ={data}
        options={options}
        ></Doughnut>
       </div>
    );
  }
}
